import React from 'react';
import clsx from 'clsx';

/**
 * Пропсы для компонента ErrorMessage
 */
interface ErrorMessageProps {
  message: string;
  className?: string;
  onDismiss?: () => void;
}

/**
 * Компонент отображения сообщений об ошибках
 * Использует DaisyUI alert компонент
 * @param message - Текст ошибки
 * @param className - Дополнительные CSS классы
 * @param onDismiss - Функция для закрытия сообщения
 * @returns JSX элемент
 */
export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className,
  onDismiss
}) => {
  const alertClasses = clsx('alert alert-error', className);

  return (
    <div className={alertClasses}>
      <i className="fas fa-exclamation-circle"></i>
      <span>{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="btn btn-sm btn-ghost btn-circle"
          aria-label="Закрыть"
        >
          <i className="fas fa-times"></i>
        </button>
      )}
    </div>
  );
};
